import { ElementRef, Injectable, inject } from '@angular/core';
import { DayOrWeekCalendarModel } from '../../../../../core/models/calendar/day-or-week-calendar.model';
import {
  TimeBlockDayOrWeekFixIntervalType,
  TimeBlockDayOrWeekVariableIntervalType,
  TimeBlockMonthFixIntervalType,
  TimeBlockMonthVariableIntervalType,
} from '../../../../../core/models/timeblock/time-block-view-type.model';
import { ShiveRenderService } from '../../../../../core/services/rendering/shive-render.service';
import { CalendarService } from '../../../services/calendar.service';
import { DragPart } from '../interaction/movement/drag-and-resize/drag-part';
import { ITimeBlockComponentItem } from '../types/time-block-component-item-types';
import { TimeBlockRenderer } from './time-block-renderer';

@Injectable()
export class TimeBlockRenderService {
  private readonly calendarService = inject(CalendarService);
  private readonly shiveRenderService = inject(ShiveRenderService);
  private readonly timeBlockRenderer: TimeBlockRenderer;

  constructor() {
    this.timeBlockRenderer = new TimeBlockRenderer(this.shiveRenderService, this.calendarService);
  }

  public toggleCalendarBodyClass(
    enable: boolean,
    dragPart: DragPart,
    calendarBodyElementRef: ElementRef,
  ): void {
    const cssClass =
      dragPart === DragPart.Top || dragPart === DragPart.Bottom || dragPart === DragPart.TopOrBottom
        ? 'resize'
        : 'drag';
    if (calendarBodyElementRef) {
      if (enable) {
        this.shiveRenderService.addClass(calendarBodyElementRef.nativeElement, cssClass);
      } else {
        this.shiveRenderService.removeClass(calendarBodyElementRef.nativeElement, cssClass);
      }
    }
  }

  public renderTimeBlock(timeBlock: ITimeBlockComponentItem): void {
    // Vertical block
    if (
      timeBlock.timeBlockModel.timeBlockViewType instanceof TimeBlockDayOrWeekVariableIntervalType
    ) {
      // For week view calendar body
      this.timeBlockRenderer.renderDayOrWeekViewVariableIntervalTimeBlock(timeBlock);
    } else if (
      timeBlock.timeBlockModel.timeBlockViewType instanceof TimeBlockDayOrWeekFixIntervalType
    ) {
      // Horizontal block for full day and week
      const calModel = this.calendarService.model as DayOrWeekCalendarModel;
      this.timeBlockRenderer.renderDayOrWeekViewFixIntervalTimeBlock(
        timeBlock,
        calModel.fixIntervalCalendarModel.geometryData.calendarBodyWidth,
      );
    } else if (
      timeBlock.timeBlockModel.timeBlockViewType instanceof TimeBlockMonthFixIntervalType
    ) {
      this.timeBlockRenderer.renderMonthViewFixIntervalTimeBlock(timeBlock);
    } else if (
      timeBlock.timeBlockModel.timeBlockViewType instanceof TimeBlockMonthVariableIntervalType
    ) {
      this.timeBlockRenderer.renderMonthViewVariableIntervalTimeBlock(timeBlock);
    } else {
      throw new Error('Time block view type not supported.');
    }
  }
}
